import { getLocale } from "../runtime";

const sv_selectcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Välj land / Select country`
};

const selectcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_selectcountry(inputs)
	return "selectCountry";
};

export { selectcountry as "selectCountry" };